<nav>
  <!-- Logo -->
  <a [routerLink]="['/', lang, 'home']" class="logo">
    <img src="../../../../assets/image/hlogo.png" alt="lcc" />
  </a>

  <!-- Desktop links -->
  <ul class="nav-links">
    <li>
      <a [routerLink]="['/', lang, 'aboutus']">{{ t.ABOUT }}</a>
    </li>
    <li>
      <a [routerLink]="['/', lang, 'services']">{{ t.Services }} </a>
    </li>
    <li>
      <a [routerLink]="['/', lang, 'subsidiaries']">{{ t.Subsidiaries }} </a>
    </li>
    <li>
      <a [routerLink]="['/', lang, 'equipment']">{{ t.Equipment }} </a>
    </li>
    <li>
      <a [routerLink]="['/', lang, 'contactus']" class="btn-contact"
        >{{ t.Contact }}
      </a>
    </li>
    <li>
      <div class="lang-dropdown">
        <button class="lang-btn" (click)="toggleLangMenu($event)">
          <i class="bi bi-globe2 icon"></i>
          {{ lang.toUpperCase() }}
        </button>

        <div class="lang-menu" *ngIf="menuOpen">
          <button (click)="switchLang('en')">EN</button>
          <button (click)="switchLang('ar')">AR</button>
        </div>
      </div>
    </li>
  </ul>

  <!-- Desktop CTA -->

  <!-- Hamburger -->
  <button
    class="hamburger"
    id="hamburger"
    [class.open]="isOpen"
    (click)="toggleMenu()"
    aria-label="Toggle menu"
  >
    <span></span><span></span><span></span>
  </button>

  <!-- Mobile menu -->
  <div class="mobile-menu" [class.open]="isOpen" id="mobileMenu">
    <a
      [routerLink]="['/', lang, 'aboutus']"
      routerLink="/aboutus"
      (click)="closeMenu()"
      >{{ t.ABOUT }}</a
    >
    <a [routerLink]="['/', lang, 'services']" (click)="closeMenu()">{{
      t.Services
    }}</a>
    <a [routerLink]="['/', lang, 'subsidiaries']" (click)="closeMenu()">{{
      t.Subsidiaries
    }}</a>
    <a [routerLink]="['/', lang, 'equipment']" (click)="closeMenu()">{{
      t.Equipment
    }}</a>
    <a
      [routerLink]="['/', lang, 'contactus']"
      (click)="closeMenu()"
      class="btn-contact"
      >{{ t.Contact }}</a
    >

    <div class="lang-switcher">
      <button [class.active]="lang === 'en'" (click)="switchLang('en')">
        EN
      </button>

      <button [class.active]="lang === 'ar'" (click)="switchLang('ar')">
        AR
      </button>
    </div>
  </div>
</nav>
